angular.module('app.api').factory('ApplicationAgentsApi', [
  'api',
  function ApplicationAgentsApi(api) {
    const applicationAgentsApi = {
      getApplicationFollowers: id => {
        return api.get(`applications/${id}/followers`)
      },
      getApplicationFollowerById: (applicationId, userId) => {
        return api.get(`applications/${applicationId}/followers/${userId}`)
      },
      updateApplicationFollowers: (id, payload) => {
        return api.put(`applications/${id}/followers`, payload)
      },
      deleteApplicationFollower: (applicationId, userId, payload) => {
        return api.delete(
          `applications/${applicationId}/followers/${userId}`,
          payload
        )
      },
      followApplicationById: (applicationId, userId, payload) => {
        return api.post(
          `applications/${applicationId}/followers/${userId}`,
          payload
        )
      },
    }
    return applicationAgentsApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/application-agent/application-agent.api.js